import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import DashboardRibbon, { IDashboardRibbonProps } from '../DashboardRibbon/DashboardRibbon';
import './DashboardSingleRibbon.scss';
import useIsInIframe from 'hooks/store/useIsInIframe';

export interface IDashboardSingleRibbonProps extends IDashboardRibbonProps {
  className?: ClassName;
}

function DashboardSingleRibbon({ theme, children, className, ...ribbonProps }: IDashboardSingleRibbonProps) {
  const isInIframe = useIsInIframe();

  return (
    <DashboardRibbon
      theme={theme}
      className={classNames('dashboard-single-ribbon', { 'is-in-iframe': isInIframe }, theme, className)}
      {...ribbonProps}
    >
      {children}
    </DashboardRibbon>
  );
}

export function DashboardSingleRibbonTextValueContent({
  value,
  title,
  subtitle,
}: {
  value: string;
  title: string;
  subtitle?: string;
}) {
  return (
    <>
      <h1 className={classNames('mb-5', 'single-ribbon-value')}>{value}</h1>
      <div className="single-ribbon-title">{title}</div>
      {subtitle !== undefined && <div className="single-ribbon-subtitle">{subtitle}</div>}
    </>
  );
}

export default DashboardSingleRibbon;
